import React from 'react'
import { Icon } from '../../shared'
import { Card, Btn } from '../../shared/components'
import { ChartLegend } from '../../shared/charts'
import { useClickOutside } from '../../shared/useClickOutside'

// Tombol overflow (···) generik, memakai mekanisme klik-di-luar dan kelas
// CSS yang sama dengan ExportMenu (components.jsx) — cuma isinya beda:
// aksi bebas (`overflowActions`), bukan pilihan format ekspor.
function CardMenu({ actions }) {
  const [open, setOpen] = React.useState(false)
  const ref = useClickOutside(open, setOpen)
  if (!actions || !actions.length) return null
  return (
    <div className="export-menu" ref={ref}>
      <Btn variant="ghost" size="sm" onClick={() => setOpen((o) => !o)} aria-label="Menu"><Icon name="more_h" size={16} /></Btn>
      {open && (
        <div className="export-menu-panel">
          {actions.map((a, i) => (
            <button
              key={i}
              className="export-menu-item"
              onClick={() => { setOpen(false); a.onClick() }}
            >
              {a.label}
            </button>
          ))}
        </div>
      )}
    </div>
  )
}

// Composite kartu statistik: Card + chart (dipasang pemanggil) + legend
// opsional + filter opsional + menu overflow opsional. Satu implementasi
// dipakai oleh keempat stat card di AdminDashboardHome, bukan 4 kartu
// bespoke terpisah.
export function StatCard({ title, eyebrow, chart, legendItems, filter, overflowActions, footnote }) {
  const action = (filter || (overflowActions && overflowActions.length)) ? (
    <div className="row gap-2" style={{ alignItems: 'center' }}>
      {filter && (
        <select
          value={filter.value}
          onChange={(e) => filter.onChange(e.target.value)}
          style={{ height: 30, padding: '0 6px', background: 'var(--surface)', border: '1px solid var(--border-strong)', fontSize: 12 }}
        >
          {filter.options.map((o) => (
            <option key={o.value} value={o.value}>{o.label}</option>
          ))}
        </select>
      )}
      <CardMenu actions={overflowActions} />
    </div>
  ) : null

  return (
    <Card title={title} eyebrow={eyebrow} action={action}>
      {chart}
      {legendItems && legendItems.length >= 2 && <ChartLegend items={legendItems} />}
      {footnote && <div className="tiny muted mt-2">{footnote}</div>}
    </Card>
  )
}
